import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const handleViewResume = () => {
    window.open('/assets/resume/Harsh_Tiwari.pdf', '_blank');
  };

  const handleContactClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-muted/20 pt-16">
      <div className="w-full max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-8 animate-fade-in">
          {/* Main Headline */}
          <div className="space-y-4">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground leading-tight">
              Full-Stack Developer
              <span className="block text-primary mt-2">
                MERN Specialist
              </span>
            </h1>
            <p className="text-lg sm:text-xl lg:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Experienced MERN stack developer proficient in Next.js and Nest.js, hailing from Lucknow, India. Crafting seamless digital experiences to enhance your web presence. Dive into my portfolio and let's collaborate on your project!
            </p>
          </div>

          {/* Professional Stats */}
          <div className="flex flex-wrap justify-center items-center gap-8 py-6">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">2+</div>
              <div className="text-sm text-muted-foreground">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">15+</div>
              <div className="text-sm text-muted-foreground">Projects Completed</div>
            </div>
            {/* <div className="text-center">
              <div className="text-2xl font-bold text-primary">20+</div>
              <div className="text-sm text-muted-foreground">Happy Clients</div>
            </div> */}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <Button
              variant="default"
              size="lg"
              onClick={handleViewResume}
              iconName="Eye"
              iconPosition="left"
              iconSize={20}
              className="min-w-[200px]"
            >
              View Resume
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={handleContactClick}
              iconName="Mail"
              iconPosition="left"
              iconSize={20}
              className="min-w-[200px]"
            >
              Contact Me
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="pt-12 animate-bounce">
            <Icon
              name="ChevronDown"
              size={32}
              color="var(--color-muted-foreground)"
              className="mx-auto cursor-pointer hover:text-primary transition-colors duration-200"
              onClick={() => {
                const aboutSection = document.getElementById('about');
                if (aboutSection) {
                  aboutSection?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                }
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;